import { createAction } from 'redux-actions';

import { AddDialogProps, Dialog } from './types';

const domain = 'teamleader/Services/DialogService';

export const ADD_DIALOG = `${domain}/ADD_DIALOG`;
export const addDialog = createAction(ADD_DIALOG, (type: Dialog, props: AddDialogProps<any>) => ({
  type,
  props,
}));

export const CLOSE_DIALOG = `${domain}/CLOSE_DIALOG`;
export const closeDialog = createAction(CLOSE_DIALOG, (type: Dialog) => ({
  type,
}));

export const CLOSE_ALL_DIALOGS = `${domain}/CLOSE_ALL_DIALOGS`;
export const closeAllDialogs = createAction(CLOSE_ALL_DIALOGS);

export type Actions =
  | ReturnType<typeof addDialog>
  | ReturnType<typeof closeDialog>
  | ReturnType<typeof closeAllDialogs>;
